import { IStyle } from '@fluentui/react';

import { IH2OTheme } from '../../models/components.models';
import { BoxShadow, FontSizes, FontWeights, Sizes } from '../../themes/styles';

export interface INotificationStyles {
  root: IStyle;
  title: IStyle;
  buttonContainer: IStyle;
  count: IStyle;
  calloutContainer: IStyle;
  header: IStyle;
  headerSecondContent: IStyle;
}

export interface INotificationClassNames {
  root: string;
  title: string;
  buttonContainer: string;
  count: string;
  calloutContainer: string;
  header: string;
  headerSecondContent: string;
}

export const notificationStylesDefault = (theme: IH2OTheme): Partial<INotificationStyles> => ({
  root: {
    display: 'inline-block',
    lineHeight: 0,
    '&.no-notifications': {
      '.h2o-Notification-count': {
        display: 'none',
      },
    },
  },
  title: {
    fontSize: FontSizes.small,
    fontWeight: FontWeights.semiBold,
    padding: Sizes.padding,
  },
  buttonContainer: {
    display: 'inline-block',
    position: 'relative',
  },
  count: {
    position: 'absolute',
    top: '-6px',
    left: '17px',
    background: theme.palette?.red200,
    fontWeight: FontWeights.bold,
    borderRadius: Sizes.borderRadius,
    height: 19,
    paddingLeft: '4px',
    paddingRight: '4px',
    textAlign: 'center',
    lineHeight: 19,
    fontSize: FontSizes.xxsmall,
    boxShadow: BoxShadow,
    cursor: 'pointer',
  },
  calloutContainer: {
    width: '541px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  headerSecondContent: {
    paddingTop: Sizes.padding,
    paddingRight: Sizes.padding,
  },
});
